import styled from '@emotion/styled/macro';

import Button from '../../../../../styledComponents/UI/Button/Button';

export const StyledButton = styled(Button)`
  min-width: 8.25rem;
`;
